import { render, staticRenderFns } from "./Heavy.vue?vue&type=template&id=eb06b9ee&scoped=true"
import script from "./Heavy.vue?vue&type=script&lang=js"
export * from "./Heavy.vue?vue&type=script&lang=js"
import style0 from "./Heavy.vue?vue&type=style&index=0&id=eb06b9ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb06b9ee",
  null
  
)

export default component.exports